
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"22","viewBox":"0 0 21 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.4752 1.02464C20.2866 0.836187 20.0512 0.701375 19.7932 0.634067C19.5353 0.566758 19.264 0.569382 19.0074 0.641668L1.5391 5.56858C1.24519 5.65147 0.98358 5.8221 0.789239 6.05765C0.594897 6.29321 0.477084 6.58247 0.451545 6.88678C0.426006 7.19109 0.493958 7.49594 0.64632 7.76059C0.798682 8.02525 1.02819 8.23709 1.30418 8.36781L8.61045 11.8287L13.6057 6.83347C13.7463 6.69281 13.9371 6.61379 14.136 6.61379C14.335 6.61379 14.5257 6.69281 14.6664 6.83347C14.8071 6.97413 14.8861 7.16491 14.8861 7.36384C14.8861 7.56276 14.8071 7.75354 14.6664 7.8942L9.67118 12.8894L13.1321 20.1957C13.2519 20.4528 13.4429 20.6701 13.6823 20.8222C13.9218 20.9742 14.1997 21.0546 14.4834 21.0537C14.5263 21.0537 14.5696 21.0519 14.6131 21.0483C14.918 21.0245 15.208 20.9073 15.4439 20.7127C15.6798 20.5181 15.85 20.2555 15.9313 19.9608L20.8582 2.4925C20.9304 2.23586 20.933 1.96463 20.8657 1.70665C20.7984 1.44868 20.6636 1.21328 20.4752 1.02464Z","fill":"#FFFFFF"}})])
          )
        }
      }
    